/**
 * Scalexa Group — cinco líneas de servicio + SaaS (Próximamente).
 * Fuente única de verdad para el menú, la portada, /services y las
 * páginas de detalle. Los nombres y el orden deben mantenerse
 * coherentes en todo el sitio.
 */

// Web oficial de VYTA Digital (socio tecnológico) — verificada: https://vytadigital.com/
export const VYTA_URL = "https://vytadigital.com/";

export const TESTIMONIALS = [
    {
        q: "Scalexa no nos vendió IA, rediseñó nuestro motor comercial. A los seis meses, nuestra previsión es por fin algo que el comité ejecutivo se cree.",
        a: "Alejandro Valcarce · VYTA Digital",
    },
    {
        q: "Teníamos tres proveedores de IA y cero impacto en pipeline. Scalexa entró, mapeó el motor comercial y en un trimestre nuestro outbound funcionaba solo.",
        a: "Miguel Pardinas · COO de Fidexa Solutions",
    },
];

export const SERVICES = [
    {
        slug: "consultoria-ia",
        n: "01",
        name: "Consultoría e implementación de IA",
        short: "Consultoría de inteligencia artificial para empresas: aplicamos la IA a los procesos que más impacto tienen en tu negocio, de la identificación de oportunidades a la adopción.",
        main: "Aplicamos inteligencia artificial a los procesos que más impacto tienen en tu negocio, desde la identificación de oportunidades hasta su implementación y adopción.",
        audience:
            "Para empresas que intuyen el valor de la IA pero no saben por dónde empezar, organizaciones con procesos manuales que consumen horas del equipo, y direcciones que han acumulado pilotos o proveedores sin un impacto medible en el negocio.",
        whatWeDo: [
            "Diagnóstico de procesos y oportunidades de mejora.",
            "Identificación y priorización de casos de uso.",
            "Automatización de tareas y flujos de trabajo.",
            "Integración con herramientas y sistemas existentes.",
            "Formación y acompañamiento a los equipos.",
            "Medición del impacto de las soluciones.",
        ],
        deliverables: [
            "Mapa de procesos con oportunidades de IA priorizadas por impacto y viabilidad.",
            "Plan de implementación por fases, con alcance y entregables definidos.",
            "Soluciones implementadas e integradas con tus sistemas actuales.",
            "Documentación, formación del equipo y acompañamiento en la adopción.",
            "Cuadro de mando para medir el impacto de cada solución.",
        ],
        howWeWork: [
            { t: "Diagnóstico", d: "Analizamos tus procesos y detectamos dónde la IA genera más valor." },
            { t: "Priorización", d: "Seleccionamos contigo los casos de uso con mayor retorno y menor fricción." },
            { t: "Implementación", d: "Desarrollamos e integramos las soluciones por fases, con entregables claros." },
            { t: "Adopción y medición", d: "Formamos a los equipos y medimos el impacto real de cada solución." },
        ],
        extra: {
            title: "Cómo colaboramos con VYTA Digital",
            body: "Scalexa coordina el proyecto y aporta la visión de negocio: qué procesos transformar, con qué prioridad y cómo medir el resultado. VYTA Digital, como especialista tecnológico, se encarga del desarrollo y la implementación de las soluciones. Tú tienes un único interlocutor y un proyecto orientado a resultados, no a tecnología por sí misma.",
        },
        modality: "Proyectos con alcance, fases y entregables definidos.",
        cta: "Evaluar un proyecto de IA",
        testimonial: 0,
        seo: {
            title: "Consultoría e implementación de IA · Scalexa Group",
            description:
                "Consultoría de inteligencia artificial para empresas: diagnóstico de procesos, automatización, integración con tus sistemas, formación de equipos y medición del impacto.",
        },
    },
    {
        slug: "aceleracion-comercial",
        n: "02",
        name: "Aceleración comercial",
        short: "Consultoría comercial y aceleración de ventas: estrategia y ejecución para captar clientes, mejorar la conversión y crecer de forma sostenible.",
        main: "Diseñamos y ejecutamos estrategias para captar clientes, mejorar la conversión y desarrollar un crecimiento comercial sostenible.",
        audience:
            "Para empresas B2B y B2C que quieren más y mejores clientes: equipos comerciales sin un proceso definido, pipelines imprevisibles, o compañías que quieren abrir nuevos canales o mercados con orden.",
        whatWeDo: [
            "Diagnóstico y estrategia comercial.",
            "Cliente ideal, segmentación y propuesta de valor.",
            "Estrategias de captación para negocios B2B y B2C.",
            "Diseño y mejora del proceso de ventas.",
            "Gestión del pipeline, CRM, indicadores y previsiones.",
            "Negociación, fidelización y desarrollo de cuentas.",
            "Canales comerciales y expansión internacional.",
        ],
        deliverables: [
            "Diagnóstico comercial y estrategia de crecimiento priorizada.",
            "Definición de cliente ideal, segmentación y propuesta de valor.",
            "Proceso de ventas documentado, de la captación al cierre.",
            "CRM ordenado, con indicadores, pipeline y previsiones fiables.",
            "Playbooks de negociación, fidelización y desarrollo de cuentas.",
        ],
        howWeWork: [
            { t: "Diagnóstico", d: "Analizamos tu situación comercial: mercado, proceso, equipo y números." },
            { t: "Estrategia", d: "Definimos contigo las prioridades y el plan de crecimiento." },
            { t: "Ejecución", d: "Implementamos el proceso, las herramientas y los hábitos comerciales." },
            { t: "Acompañamiento", d: "Revisamos resultados de forma recurrente y ajustamos el plan." },
        ],
        extra: {
            title: "MEDDPICC para ventas B2B complejas",
            body: "En procesos de venta largos y con varios interlocutores aplicamos MEDDPICC, una metodología de cualificación reconocida internacionalmente. En la práctica es una lista disciplinada de preguntas —qué métricas mueven al cliente, quién decide y cómo, qué criterios se valoran, qué problema se resuelve y quién defiende el proyecto internamente— que permite priorizar las oportunidades correctas y prever las ventas con mucha más fiabilidad.",
        },
        modality: "Proyectos de mejora y acompañamiento recurrente.",
        cta: "Impulsar mis ventas",
        testimonial: 1,
        seo: {
            title: "Aceleración comercial y consultoría de ventas · Scalexa",
            description:
                "Consultoría comercial para empresas B2B y B2C: estrategia de ventas, CRM, pipeline, negociación y expansión internacional con método (MEDDPICC).",
        },
    },
    {
        slug: "sdr-externo",
        n: "03",
        name: "SDR externo y prospección B2B",
        short: "Externaliza tu prospección B2B: una operación coordinada que conecta tu empresa con los decisores adecuados y desarrolla oportunidades.",
        main: "Coordinamos una operación de prospección B2B que conecta tu empresa con los decisores adecuados y desarrolla oportunidades para tu equipo comercial.",
        audience:
            "Para empresas B2B cuyo equipo comercial dedica demasiado tiempo a buscar contactos en lugar de cerrar oportunidades, y para compañías que quieren abrir mercado sin crear un departamento de prospección interno.",
        whatWeDo: [
            "Definición de cuentas y perfiles objetivo.",
            "Investigación y preparación de contactos.",
            "Mensajes y secuencias de prospección.",
            "Contacto, seguimiento y cualificación.",
            "Coordinación de reuniones comerciales.",
            "Registro de actividad y oportunidades en CRM.",
            "Seguimiento de resultados y mejora continua.",
        ],
        deliverables: [
            "Definición de cuentas y perfiles objetivo.",
            "Base de contactos investigada y preparada.",
            "Mensajes y secuencias de prospección a tono con tu marca.",
            "Reuniones comerciales cualificadas y coordinadas.",
            "Actividad y oportunidades registradas en tu CRM.",
            "Informes periódicos de resultados y aprendizajes.",
        ],
        howWeWork: [
            { t: "Definición", d: "Acordamos cuentas objetivo, perfiles y criterios de cualificación." },
            { t: "Preparación", d: "Investigamos contactos y construimos los mensajes y secuencias." },
            { t: "Ejecución", d: "Contactamos, hacemos seguimiento y cualificamos cada oportunidad." },
            { t: "Revisión", d: "Analizamos resultados contigo y mejoramos la operación cada ciclo." },
        ],
        extra: {
            title: "Una operación coordinada por Scalexa",
            body: "La ejecución se realiza mediante colaboradores especializados en prospección, coordinados directamente por Scalexa: definimos la estrategia, supervisamos la calidad y nos aseguramos de que cada reunión llegue a tu equipo con el contexto necesario. Las reuniones y oportunidades se cualifican según criterios acordados contigo al inicio del servicio, y los resultados se revisan de forma periódica.",
        },
        modality: "Servicio recurrente con alcance y objetivos definidos.",
        cta: "Desarrollar mi prospección B2B",
        testimonial: null,
        seo: {
            title: "SDR externo y prospección B2B · Scalexa Group",
            description:
                "Externaliza tu prospección B2B: cuentas objetivo, secuencias, cualificación y reuniones para tu equipo comercial, coordinado por Scalexa y registrado en CRM.",
        },
    },
    {
        slug: "direccion-liderazgo",
        n: "04",
        name: "Dirección empresarial y desarrollo de líderes",
        short: "Dirección externa e interim management: experiencia directiva para organizar, liderar y ejecutar el crecimiento, desarrollando a tus responsables y equipos.",
        main: "Aportamos experiencia directiva para organizar, liderar y ejecutar el crecimiento de tu empresa, mientras desarrollamos las capacidades de sus responsables y equipos.",
        audience:
            "Para empresas en crecimiento que necesitan dirección experimentada sin incorporarla en plantilla, y para organizaciones cuyos responsables asumen equipos sin formación ni acompañamiento directivo.",
        modalities: [
            {
                title: "Dirección externa",
                items: [
                    "Dirección comercial o general según el mandato.",
                    "Definición de prioridades y planes de ejecución.",
                    "Organización de equipos y responsabilidades.",
                    "Seguimiento de presupuestos, márgenes e indicadores.",
                    "Coordinación entre áreas.",
                    "Apoyo en decisiones, contratación y desarrollo del equipo.",
                ],
            },
            {
                title: "Desarrollo de líderes",
                items: [
                    "Acompañamiento ejecutivo.",
                    "Formación de responsables y mandos.",
                    "Liderazgo comercial y gestión de equipos.",
                    "Delegación, negociación y seguimiento del rendimiento.",
                ],
            },
        ],
        modalitiesNote:
            "Puedes contratar dirección externa, formación y acompañamiento, o una combinación de ambas modalidades.",
        whatWeDo: null,
        deliverables: [
            "Plan de dirección con prioridades y planes de ejecución.",
            "Organización de equipos, roles y responsabilidades.",
            "Cuadro de mando con presupuestos, márgenes e indicadores.",
            "Programa de desarrollo de líderes con acompañamiento ejecutivo.",
        ],
        howWeWork: [
            { t: "Diagnóstico", d: "Entendemos la situación de la empresa, el equipo y el mandato." },
            { t: "Mandato", d: "Acordamos responsabilidades, objetivos y dedicación." },
            { t: "Ejecución", d: "Dirigimos prioridades, equipos e indicadores con ritmo semanal." },
            { t: "Desarrollo", d: "Formamos y acompañamos a los responsables para que el cambio dure." },
        ],
        modality: "Dirección externa, formación y acompañamiento, o una combinación de ambas.",
        cta: "Explorar una colaboración directiva",
        testimonial: null,
        seo: {
            title: "Dirección externa y desarrollo de líderes · Scalexa",
            description:
                "Dirección externa e interim management para pymes en crecimiento: prioridades, equipos e indicadores, con formación y acompañamiento de líderes.",
        },
    },
    {
        slug: "caio-externo",
        n: "05",
        name: "CAIO externo — Dirección de IA",
        short: "Chief AI Officer externo: dirección de la estrategia de IA con visión de negocio, prioridades claras y seguimiento continuo de su impacto.",
        definition:
            "CAIO significa Chief AI Officer: responsable de la estrategia y dirección de inteligencia artificial.",
        main: "Dirigimos la adopción de inteligencia artificial con una visión de negocio, prioridades claras y seguimiento continuo de su impacto.",
        audience:
            "Para direcciones que quieren incorporar IA con criterio —sin perseguir modas ni multiplicar proveedores— y necesitan a quien defina la estrategia, coordine a los especialistas y rinda cuentas del impacto.",
        whatWeDo: [
            "Definición de la hoja de ruta de IA.",
            "Priorización de iniciativas e inversiones.",
            "Coordinación de proveedores y especialistas.",
            "Criterios internos para el uso y la supervisión de la IA.",
            "Seguimiento de la implantación y la adopción.",
            "Evaluación de costes, beneficios y resultados.",
            "Acompañamiento a la dirección en decisiones relacionadas con la IA.",
        ],
        deliverables: [
            "Hoja de ruta de IA priorizada y alineada con el negocio.",
            "Criterios internos para el uso y la supervisión de la IA.",
            "Coordinación de proveedores y especialistas bajo un único criterio.",
            "Informes periódicos de implantación, adopción, costes y beneficios.",
        ],
        howWeWork: [
            { t: "Hoja de ruta", d: "Definimos la estrategia de IA y sus prioridades de inversión." },
            { t: "Coordinación", d: "Dirigimos a proveedores y especialistas con un único criterio." },
            { t: "Supervisión", d: "Establecemos criterios internos de uso y control de la IA." },
            { t: "Seguimiento", d: "Medimos adopción, costes y resultados, e informamos a dirección." },
        ],
        extra: {
            title: "¿En qué se diferencia de la Consultoría de IA?",
            body: "La consultoría de IA desarrolla proyectos concretos, con principio y fin. El CAIO externo dirige y coordina de forma continua la estrategia de IA de la empresa: decide qué se hace, en qué orden, con quién y con qué resultados.",
        },
        modality: "Acompañamiento directivo recurrente, con dedicación y responsabilidades acordadas.",
        cta: "Explorar el servicio de CAIO externo",
        testimonial: null,
        seo: {
            title: "CAIO externo — Dirección de IA · Scalexa Group",
            description:
                "Chief AI Officer externo (CAIO): dirección continuada de la estrategia de IA, hoja de ruta, coordinación de proveedores y medición de resultados.",
        },
    },
];

export const SAAS = {
    slug: "saas",
    name: "SaaS de Scalexa",
    badge: "Próximamente",
    text: "Estamos preparando nuestra próxima solución SaaS. Pronto compartiremos más información sobre el producto y su disponibilidad.",
    cta: "Recibir novedades",
};

export const INTEREST_OPTIONS = [
    ...SERVICES.map((s) => ({ value: s.slug, label: s.name })),
    { value: "saas", label: "SaaS — Próximamente" },
    { value: "otro", label: "Otro / aún no lo tengo claro" },
];
